<template>
    <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :searchs="searchs" :operate="[]" :permission="permission"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "PidSecret",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'pidSecret:add',
                    update: 'pidSecret:update',
                    delete: 'pidSecret:delete',
                    deleteBatch: 'pidSecret:deleteBatch'
                },
                url: {
                    get: '/pidSecret/listByCondition',
                    add: '/pidSecret/add',
                    update: '/pidSecret/update',
                    delete: '/pidSecret/delete/',
                    delete_batch: '/pidSecret/deleteBatch',
                },
                searchs: [{
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                }, {
                    field: 'pid',
                    label: '公司PID',
                    show: true,
                    width: '',
                }, {
                    field: 'md5Secret',
                    label: '秘钥',
                    show: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '启用',
                                type: 'success'
                            },{
                                key: 0,
                                value: '禁用',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '80',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: [ {
                        field: 'status',
                        label: '状态',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '启用',
                        }, {
                            id: 0,
                            name: '禁用',
                        }],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
